import React, { useContext, useState } from "react";
import Exit from "../../assets/icons/exit.png";
import styled from "styled-components";
import { AuthContext } from '../../../../Contexts/auth';
import ChatbotIcon from "../../assets/icons/Chatbot.png";
import "./Profile.css"
import ChatbotModal from "Components/ChatbotModal/ChatbotModal";
import { useChatbot } from '../../../../Contexts/ChatbotContext';

const Name = styled.div`
  display: block;
  margin: 0px 8px 0px 0px;
  color: white;
  font-weight: 500;
  max-width: 40vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const Logout = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const Profile = () => {
  const { logout, user } = useContext(AuthContext);
  const { isModalOpen, setIsModalOpen } = useChatbot();

  const handleLogout = () => {
    logout();
  };

  const toggleChatbot = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="header-profile">
      {isModalOpen && <ChatbotModal onClose={toggleChatbot} />}

      <button onClick={toggleChatbot}
        style={{
          margin: '0px 30px 0px 0px',
          backgroundColor: 'transparent',
          filter: 'invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%)',
          border: '0px'
        }}
        className="chatbot-toggle">
        {/*
        <img src={ChatbotIcon} alt="Abrir Chatbot" style={{ maxHeight: '25px', maxWidth: '25px', width: '25px', margin: "0px" }} 
        />*/}
      </button>

      <Name title={user.name}>{user.name}</Name>

      <Logout onClick={handleLogout} title="Sair" aria-label="Sair">
        <img id="exit-image" src={Exit} alt="logout" />
      </Logout>

    </div>
  );
};

export default Profile;
